module.exports = __webpack_public_path__ + "static/img/88034D_1_2_C_20240305_fit.d3a3fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88034D_1_2_C_20240305_fit.png
// module id = P8sd
// module chunks = 0